
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep3 {
  agencyType: string;
  agency: string;
  agencyOther: string;
  isRequiredGrant: string;
}

export default defineComponent({
  name: "step-3",
  components: {
    Field,
    ErrorMessage,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];
    const step3 = ref<IStep3>({
      agencyType: "Not Funded Research",
      agency: "",
      agencyOther: "",
      isRequiredGrant: "0",
    });

    const isShowOtherAgency = computed(() => {
      return (
        step3?.value?.agency === "State Agency" ||
        step3?.value?.agency === "Company" ||
        step3?.value?.agency === "Organization" ||
        step3?.value?.agency === "Others"
      );
    });

    const isNotFundedResearch = computed(() => {
      return step3?.value?.agencyType === "Not Funded Research";
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      step3.value.agencyType = data?.data?.agencyType || "";
      step3.value.agency = data?.data?.agency || "";
      step3.value.agencyOther = data?.data?.agencyOther != null && data?.data?.agencyOther != undefined? data?.data?.agencyOther: "";
      step3.value.isRequiredGrant = data?.data?.isRequiredGrant ? "1" : "0";
    });

    return {
      step3,
      Field,
      isShowOtherAgency,
      isNotFundedResearch,
      listDropDownSections,
    };
  },
});
